import React from 'react';
import ReactDOM from 'react-dom';

interface CommentBannerPositionerProps {
    children: any,
    isMobile?: boolean,
}

// temporary component to call CommentBanner,
// as cshtml cannot render CommentBanner with HOC at the moment
const CommentBannerPositioner = function CommentBannerPositioner({ children, isMobile }: CommentBannerPositionerProps) {
    const container = document.getElementById('comments-tile');
    if (!container) {
        return <div />;
    }

    // data-keyelement is an attribute in the placeholder. If it exist, remove it.
    if (container.firstElementChild && (container.firstElementChild as HTMLElement).dataset.keyelement) {
        container.firstElementChild.remove();
    }

    // check for classNames set by editor to hide widgets on mobile and desktop
    const showBanner = isMobile
        ? !container.className.includes('is-hidden-mobile')
        : !container.className.includes('is-hidden-tablet');

    if (showBanner) {
        // wrapper for margin from template.
        const banner = (
            <div className="tile is-parent is-paddingless-mobile" id="comments-target">
                {children}
            </div>
        );

        return ReactDOM.createPortal(
            banner,
            container,
        );
    }

    return <div />;
};

export default CommentBannerPositioner;
